import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled from 'styled-components';

/**
 * This CSS is based on 18F's `.sr-only` class (https://accessibility.18f.gov/hidden-content/)
 * */
var HiddenElement = /*#__PURE__*/styled.span.withConfig({
  displayName: "VisuallyHidden__HiddenElement",
  componentId: "znuy2i-0"
})(["border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;"]);
export var VisuallyHidden = function VisuallyHidden(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(HiddenElement, rest, children);
};
export default VisuallyHidden;